import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { catchError, switchMap, tap, throwError } from 'rxjs';
import { LoginReq } from 'src/app/api/contracts/auth';
import { AuthService } from 'src/app/auth/auth.service';
import { APP_CONFIG, AppConfig } from 'src/app/config/app-config';
import { ModalService } from 'src/app/services/modal.service';
import { LoaderController } from 'src/app/utils/loader-controller';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./../auth-common.scss', './forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  readonly form: FormGroup<Record<keyof Pick<LoginReq, 'email'>, FormControl>>;
  readonly loader = new LoaderController();

  constructor(
    private readonly navCtrl: NavController,
    private readonly modalService: ModalService,
    private readonly authService: AuthService,
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig
  ) {
    this.form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(this.appConfig.fieldValidation.email.pattern),
      ]),
    });
  }

  ngOnInit() {
    return;
  }

  onResetPasswordClick(): void {
    if (this.loader.isLoadingNow()) {
      return;
    }
    this.loader.enqueue();
    const email = this.form.value.email as string;
    this.authService
      .sendForgottenPasswordRequest({ email })
      .pipe(
        catchError((err) => {
          this.loader.dequeue();
          return throwError(() => err);
        }),
        tap(() => this.loader.dequeue()),
        switchMap(() =>
          this.modalService.showForgotPasswordConfirmationModal(email)
        )
      )
      .subscribe(() => {
        this.navCtrl.navigateRoot('login');
      });
  }

  onCancelClick(): void {
    this.navCtrl.pop().then((canGoBack) => {
      !canGoBack && this.navCtrl.navigateRoot('login');
    });
  }
}
